import type { AIImageGenerationPluginOptions } from '@atlassian/editor-plugin-ai-image-generation/aiImageGenerationPluginOptions';

interface Props {
	options: AIImageGenerationPluginOptions;
}

export function aiImageGenerationPluginOptions({ options }: Props): AIImageGenerationPluginOptions {
	return options;
}
